<!--
 * @Author: zhangzhitao
 * @Date: 2019-10-22 09:35:42
 * @LastEditors: zhangzhitao
 * @LastEditTime: 2019-12-02 14:02:25
 * @Description:
 -->
<template>
  <el-submenu
    v-if="!data.fullUrl&&data.children && data.children.length && data.isShow === 0"
    class="u-level-2"
    :title="data.name"
    :index="data.menuId"
  >
    <menu-item
      v-for="(sub, index) in data.children"
      :key="index"
      :data="sub"
      no-icon
    ></menu-item>
  </el-submenu>
  <el-menu-item
    v-else
    v-show="data.isShow === 0"
    :index="data.menuId"
  >
    {{ data.name }}
  </el-menu-item>
</template>

<script>
export default {
  name: 'menu-item',
  props: {
    data: Object,
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      defaultIcon: `this.src="${require('../../assets/images/nav_icondefault_B.png')}"`
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
.system-configuration {
  .icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    vertical-align: middle;
    position: relative;
    &.no-icon {
      background: none !important;
      width: 0;
      margin-right: 0;
    }
  }
  .is-active {
    .icon {
      &.no-icon {
        background: none !important;
        width: 0;
        margin-right: 0;
      }
    }
  }
}

.sub-title {
  min-width: 176px;
}
</style>
